export const hasRichContent = (value?: string | null): boolean => {
    if (!value) return false;

    const textOnly = value
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/g, " ")
        .trim();

    if (textOnly.length > 0) {
        return true;
    }

    return /<(img|svg|iframe|video|audio)\b/i.test(value);
};
